import * as yup from "yup";
const CredentialSchema = yup.object().shape({
    credentialTypeId: yup.number().required("Please select a credential type"),
  });

  export default CredentialSchema;